import React from 'react';
import { browserHistory } from 'react-router';

class About extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      timeout: 5000
    };
  }

  componentDidMount() {
    var id = "";
    var danceId = null;
    if(this.props.params.danceId) {
      console.log("got danceId: " + this.props.params.danceId);
      danceId = this.props.params.danceId;
    }
    setTimeout(function() {
      if(danceId) {
        id = "/" + danceId;
      }
      browserHistory.push("/booth" + id);
    }, this.state.timeout);
  }

  render() {
    return(
      <div className="full thanks">
        <div className="table">
          <div className="table-cell">
            Thanks!
          </div>
        </div>
      </div>
    )
  }
}

export default About;



// WEBPACK FOOTER //
// src/Thanks.js